import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { store } from '../../redux/store';
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import Pagination from "react-js-pagination";
import './billList.css';
import moment from "moment";
import tokenErrorHandler from "../tokenErrorHandler";
import { selectedConsumerList, setBatchConsumers } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class BatchList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            batchList: [],
            batchLoading: 'loading',
            startIndex: 0,
            endIndex: 5,
            activePage: 1

        }
    }




    componentDidMount() {

        var url = '/api/v1/billpay/corp/consumer/batch-list/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo,
            { headers }
        ).then((response) => {

            this.setState({
                batchList: response.data,
                batchLoading: 'completed'
            })

        }).catch(error => {
            this.setState({
                batchLoading: 'completed'
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });
    }
    componentWillUnmount() {
    }

    selectThisBatch = (event, batch) => {
        event.preventDefault();
        var consumers = batch.consumerList;
        store.dispatch(setBatchConsumers(consumers));

        setTimeout(() => {
           var batchConsumerId=document.getElementById('batchConsumerId');
           batchConsumerId.click();
        }, 200);
    }


    handlePageChangeDefault(pageNumber) {
        this.setState({
            activePage: pageNumber
        })

        console.log(pageNumber);
        var startIndex = (pageNumber - 1) * 5;
        var endIndex = pageNumber * 5;

        this.setState({
            startIndex: startIndex,
            endIndex: endIndex,
        })
    }


    render() {

        var headerTitle = "Batch List:";
        return (

            <div>
                <div class="main">
                    <LeftMenu />
                    <Link to="/batch-consumer">
                        <button id="batchConsumerId" hidden={true}>
                        </button>
                    </Link>

                    <div class="right-side">
                        <div class="container-fluid">

                            <Header />
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="dashhead">
                                            <h3>Batch Order List:</h3>
                                            <div class="backbtn">
                                                <Link to='/bill-history'>
                                                    <button type="button" class="back"
                                                        >Back</button>
                                                </Link>
                                            </div>
                                        </div>
                                        {this.state.batchLoading == 'loading' &&
                                            <div>Loading.....
                                                <div class="spinner-grow spinner-grow-sm"></div>
                                            </div>}

                                        {this.state.batchLoading != 'loading' &&
                                            this.state.batchList != undefined &&
                                            this.state.batchList.length > 0 &&
                                            this.state.batchList.
                                                slice(this.state.startIndex,
                                                    this.state.endIndex).
                                                map(batch => (
                                                    <div class="billist nodue">
                                                        <div class="row" onClick={e => { this.selectThisBatch(e, batch) }}>
                                                            <div class="col-12 col-md-3">
                                                                <div class="duetxt csname">
                                                                    <h5>Batch ID:</h5>
                                                                    <p>{batch.id}</p>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-5">
                                                                <div class="duetxt">
                                                                    <h5>Total Orders:</h5>
                                                                    <p>{batch.consumerList.length}</p>
                                                                </div>
                                                            </div>


                                                            <div class="col-6 col-md">
                                                                <div class="duetxt">
                                                                    <p>Batch Created:</p>
                                                                    <h5>{batch.createdOn != undefined ? moment(batch.createdOn).format('DD-MM-YYYY HH:mm:ss') :
                                                                        "NA"}</h5>
                                                                </div>
                                                            </div>
                                                            <div class="col-6 col-md">
                                                                <div class="duetxt text-end">
                                                                    <p>Batch Updated:</p>
                                                                    <h5>{moment(batch.updateOn).format('DD-MM-YYYY HH:mm:ss')}</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                        }
                                        {this.state.batchLoading != 'loading' &&
                                            this.state.batchList != undefined &&
                                            this.state.batchList.length == 0 &&
                                            <div>No Batch Found!</div>}

                                        {this.state.batchLoading != 'loading' &&
                                            this.state.batchList != undefined &&
                                            this.state.batchList.length > 0 &&
                                            <div class="pager">
                                                <p>Showing {this.state.startIndex + 1} to {this.state.endIndex >=
                                                    this.state.batchList.length ?
                                                    this.state.batchList.length :
                                                    this.state.endIndex} of {this.state.batchList.length} entries</p>
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={5}
                                                    totalItemsCount={
                                                        this.state.batchList.length}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChangeDefault.bind(this)}
                                                    className="pagination"
                                                    linkClass="page-link"
                                                    itemClass="page-item"
                                                />
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage },
        miscReduce: { phone, token, agentInfo, deviceInfo, clientRole } }
) => ({
    errorMessage, phone, token, agentInfo, deviceInfo, clientRole
});

export default connect(mapStateToProps, null)(BatchList);
